<template>
  <div  :class="name">
    <div class="btn" v-for="(item, key) in items" :key="key" @click="set(item)" :class="isActive(item)">
      {{item.name}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputButton',
  props: {
    name: {
      type: String,
      default: () => ''
    },
    handler: {
      type: String,
      default: () => null
    },
    groupIndex: {
      type: Number,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    },
    currentValue: {
      type: String,
      default: () => null
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    set(item) {
      const { name, groupIndex, index, handler } = this
      this.$emit('set', { name, item, groupIndex, index, handler })
    },
    isActive(item) {
      return item.id === this.currentValue ? 'active' : ''
    }
  }
}
</script>

<style>
.btn{
  margin-bottom: 8px;
  width: 142px;
  height: 32px;
  border: 1px solid #2d9cdb;
  box-sizing: border-box;
  border-radius: 4px;
  background: #fff;
  color: #2d9cdb;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.active{
  background-color: #2d9cdb;
  color: #fff;
  }

</style>
